import useAppStore from "@/context/store";
import { useLocalStorageState } from "ahooks";
import { Tabs } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import styles from "../index.module.less";
import PinRecommendPinList from "../PinRecommendPinList";
import PinRelatedBoardList from "../PinRelatedBoardList";
export default function Index({ isModal, pin, relatedBoards }) {
  const { headerHeight } = useAppStore(({ headerHeight }) => ({
    headerHeight,
  }));
  //推荐导航栏高度
  const navHeight = 43;
  // 搜索栏高度
  const searchHeight = 80;
  // 推荐列表最小高度需要减去的部分
  const reduceHeight = useMemo(() => {
    let height = 0;
    if (!isModal) {
      height = headerHeight + searchHeight + navHeight;
    } else {
      // 弹窗情况下
      height = navHeight + 70;
    }
    return height;
  }, [headerHeight, isModal]);
  const [userRecommendType, setUserRecommendType] = useLocalStorageState(
    "PIN_DETAIL_RECOMMEND_TYPE",
    {
      defaultValue: "board",
    }
  );
  const [isUserTabChange, setIsUserTabChange] = useState(false); // 用于标记是否是用户切换Tab
  const [recommendType, setRecommendType] = useState("board");

  const { TabPane } = Tabs;
  useEffect(() => {
    setRecommendType(userRecommendType);
  }, [userRecommendType]);
  // 用户主动切换Tab情况
  const userSelectTab = (tab) => {
    // 切换tab滚动到初始位置
    let target = document.querySelector("#pin_detail");
    // 获取dom元素的可视高度 + nav到详情的距离
    let top = target.clientHeight + 55;
    // 判断是否为弹窗
    if (isModal) {
      let modalDom = document.querySelector(".pinDetailModal");
      // 如果当前滚动距离小于推荐导航置顶距离，则不进行滚动
      modalDom.scrollTop > top &&
        modalDom.scrollTo({
          top,
        });
    } else {
      // 如果当前滚动距离小于推荐导航置顶距离，则不进行滚动
      window.scrollY > top &&
        window.scrollTo({
          top,
        });
    }
    setIsUserTabChange(true); // 标记用户切换

    setUserRecommendType(tab);
    setRecommendType(tab);
  };
  // 默认加载同在画板为空的情况，切换到Tab：为你推荐
  const relatedBoardLoaded = useCallback(
    (boards) => {
      if (boards.length === 0 && !isUserTabChange) {
        setRecommendType("pin");
      }
    },
    [setRecommendType, isUserTabChange]
  );

  return (
    <>
      <div className={styles.list}>
        <div className={`${styles.wrapper} calculateWrapper`}>
          <Tabs
            className={styles.tab}
            // destroyInactiveTabPane={true}
            activeKey={recommendType}
            onChange={userSelectTab}
            tabBarStyle={{ top: isModal ? -1 : headerHeight - 1 }}
            centered
          >
            <TabPane tab="同在画板" key="board">
              <div
                data-content-source="推荐画板"
                style={{ minHeight: `calc(100vh - ${reduceHeight}px)` }}
              >
                {recommendType === "board" && pin?.pin_id && (
                  <PinRelatedBoardList
                    onFirstLoad={relatedBoardLoaded}
                    pinId={pin?.pin_id}
                    isModal={isModal}
                    initList={relatedBoards}
                    fileId={pin?.file_id}
                  />
                )}
              </div>
            </TabPane>
            <TabPane tab="为你推荐" key="pin">
              <div
                data-content-source="为你推荐"
                style={{ minHeight: `calc(100vh - ${reduceHeight}px)` }}
              >
                {recommendType === "pin" && pin?.pin_id && (
                  <PinRecommendPinList
                    pinId={pin?.pin_id}
                    isModal={isModal}
                    fileId={pin?.file_id}
                  />
                )}
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </>
  );
}
